import { render, staticRenderFns } from "./DetailRichText.vue?vue&type=template&id=1b2fe7fb&scoped=true&"
import script from "./DetailRichText.vue?vue&type=script&lang=ts&"
export * from "./DetailRichText.vue?vue&type=script&lang=ts&"
import style0 from "./DetailRichText.vue?vue&type=style&index=0&id=1b2fe7fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2fe7fb",
  null
  
)

export default component.exports